import React, { Component } from 'react';
import { SelectFieldEditor, TextFieldEditor } from '../../components';
import s from './HostStyles.module.scss';

export default class SelectFieldEditorEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { value1: '', value2: 'foo', value3: 'uber' };
    }

    render() {
        const categoryIconOptions = [
            { value: 'eat', label: 'eat', categoryIcon: 'eat' },
            { value: 'uber', label: 'uber', categoryIcon: 'uber' },
        ];

        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <div style={{ marginBottom: '20px' }}>
                    <TextFieldEditor value="Hello There" label="Text Editor" disabled />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <SelectFieldEditor label="Select Editor" selectedValue={this.state.value1} onValueSelected={selectedValue => this.setState({ value1: selectedValue })} />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <SelectFieldEditor label="disabled Select Editor" selectedValue={this.state.value1} onValueSelected={selectedValue => this.setState({ value1: selectedValue })} disabled />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <SelectFieldEditor creatable label="Select Editor Creatable" selectedValue={this.state.value2} onValueSelected={selectedValue => this.setState({ value2: selectedValue })} />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <SelectFieldEditor label="category icons" categoryIcons options={categoryIconOptions} selectedValue={this.state.value3} onValueSelected={value3 => this.setState({ value3 })} />
                </div>
            </div>
        );
    }
}
